// Файл browserLockHandlers.js

/**
 * Модуль содержит обработчики блокировки нежелательных браузерных
 * жестов и системных сочетаний клавиш.
 */



const editable_target_selector = (
    'input, textarea, select, [contenteditable="true"], '
    + '.table-widget, [data-browser-lock-allow-select="true"]'
);


const target_element = (target) => {
    if (target instanceof Element) {
        return target;
    }

    return target?.parentElement || null;
};


const is_application_editable_target = (target) => Boolean(
    target_element(target)?.closest(editable_target_selector)
);


const handleContextMenu = (event) => {
    event.preventDefault();
    return false;
};


const handleSelectStart = (event) => {
    if (is_application_editable_target(event.target)) {
        return true;
    }

    event.preventDefault();
    return false;
};


const handleDragStart = (event) => {
    const draggable_target = event.target?.closest?.(
        '[draggable="true"], [data-browser-lock-allow-drag="true"]'
    );

    if (draggable_target) {
        return true;
    }

    event.preventDefault();
    return false;
};


const handleKeyDown = (event) => {
    const application_shortcut = is_application_editable_target(event.target);
    const is_browser_shortcut =
        event.keyCode === 123
        || (event.ctrlKey && event.shiftKey && event.keyCode === 73)
        || (event.ctrlKey && event.shiftKey && event.keyCode === 74)
        || (event.ctrlKey && event.shiftKey && event.keyCode === 67)
        || (event.ctrlKey && event.keyCode === 85)
        || (event.ctrlKey && event.keyCode === 80)
        || (event.ctrlKey && event.keyCode === 82)
        || (event.ctrlKey && event.shiftKey && event.keyCode === 82)
        || (event.altKey && event.keyCode === 37)
        || (event.altKey && event.keyCode === 39)
        || event.keyCode === 44
        || (
            event.ctrlKey
            && event.keyCode === 83
            && !application_shortcut
        );

    if (is_browser_shortcut) {
        event.preventDefault();
        return false;
    }
};


const handleMouseDown = (event) => {
    if (
        event.detail > 1
        && !is_application_editable_target(event.target)
    ) {
        event.preventDefault();
    }
};


const handleKeyUp = (event) => {
    if (
        event.ctrlKey
        && event.keyCode === 65
        && !is_application_editable_target(event.target)
    ) {
        event.preventDefault();
        return false;
    }
};


const eventHandlers = [
    ['contextmenu', handleContextMenu],
    ['selectstart', handleSelectStart],
    ['dragstart', handleDragStart],
    ['keydown', handleKeyDown],
    ['keyup', handleKeyUp],
    ['mousedown', handleMouseDown],
];


export { eventHandlers };
